/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Injectable,
  ComponentFactoryResolver,
  ApplicationRef,
  Injector,
  EmbeddedViewRef,
  ComponentRef,
} from '@angular/core';
import { SnackbarModule } from './snackbar.module';
import { SnackbarComponent } from './snackbar.component';
import { SnackbarInjector } from './snackbar.injector';
import { SnackbarRef } from './snackbar.ref';
import { SnackbarConfig } from './snackbar.config';

@Injectable({
  providedIn: SnackbarModule,
})
export class SnackbarService {
  snackbarComponentRef!: ComponentRef<SnackbarComponent>;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  public open(config: SnackbarConfig) {
    const snackbarRef = this.appendSnackbarComponentToBody(config);

    return snackbarRef;
  }

  private appendSnackbarComponentToBody(config: SnackbarConfig) {
    const map = new WeakMap();
    map.set(SnackbarConfig, config);

    const snackbarRef = new SnackbarRef();
    map.set(SnackbarRef, snackbarRef);

    const sub = snackbarRef.afterClosed.subscribe(() => {
      this.removeSnackbarComponentFromBody();
      sub.unsubscribe();
    });

    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(SnackbarComponent);
    const componentRef = componentFactory.create(
      new SnackbarInjector(this.injector, map)
    );

    for (const key in config) {
      if (config.hasOwnProperty(key)) {
        // @ts-ignore
        componentRef.instance[key as any] = config[key as any];
      }
    }

    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);

    this.snackbarComponentRef = componentRef;

    this.snackbarComponentRef.instance.onClose.subscribe(() => {
      this.removeSnackbarComponentFromBody();
    });

    return snackbarRef;
  }

  private removeSnackbarComponentFromBody() {
    if (!this.snackbarComponentRef) return;
    this.appRef.detachView(this.snackbarComponentRef.hostView);
    this.snackbarComponentRef.destroy();
  }
}
